import logoUrl from "@/assets/logo-mpb.jpg";
import { SITE } from "@/lib/data";

export const Logo = ({ className = "h-10 w-10" }) => (
  <img
    src={logoUrl}
    alt={`Logo ${SITE.name}`}
    className={`${className} shrink-0 rounded-full object-cover`}
    loading="eager"
    data-testid="site-logo"
  />
);
